import classNames from "classnames";
import React, { ReactElement, memo, useMemo } from "react";
import styles from "./threeDotAnimation.scss";

const ThreeDotAnimation = (): ReactElement => {
    const firstDotStyle = useMemo(() => classNames(styles.threedotAnimatiion, styles.firstDot), []);
    const secondDotStyle = useMemo(() => classNames(styles.threedotAnimatiion, styles.secondDot), []);
    const thirdDotStyle = useMemo(() => classNames(styles.threedotAnimatiion, styles.thirdDot), []);
    return (
        <>
            <span className={firstDotStyle}>.</span>
            <span className={secondDotStyle}>.</span>
            <span className={thirdDotStyle}>.</span>
        </>
    );
};

export default memo(ThreeDotAnimation);
